import { getAPI, postAPI, putAPI } from "../../../../api/apis";
import { REACT_APP_CANDIDATE , REACT_APP_CANDIDATE_FREELANCER , REACT_APP_CONTRACT} from "../../../../utils/common";

export async function getQuestions() {
    const Details = getAPI( REACT_APP_CANDIDATE + '/survey-questions')
    return Details
}

export async function updateSurveyData(body: any) {
    const Details = putAPI( REACT_APP_CANDIDATE + '/survey-data', body)
    return Details
}

export async function getDetails(Id: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE + `/candidates/${Id}`)
    return Details
}

export async function getJobsForCandidate(body: any) {
    const loginId = localStorage.getItem('loginId') || ''
    const Details = postAPI( REACT_APP_CANDIDATE_FREELANCER + `/job-dashboard?candidateId=${loginId}`, body)
    return Details
}

export async function getFulltimeJobs(data: any) {
    const Details = postAPI( REACT_APP_CONTRACT + `/full-time-job`,data)
    return Details
}
